import {
  LeadOrigin,
  Application,
  fetchPostApplication,
  fetchPostLead,
  LeadCreationResponse,
} from "@justhome/api-core";
import mapFormToApplication from "./mapFormToApplication";
import { ContactFormValues, FormValues } from "./types";

interface SaveApplicationAndLeadProps {
  form: FormValues;
  contactForm: ContactFormValues;
  partnerId?: string;
  origin?: LeadOrigin[];
  consentText?: string;
}

const saveApplicationAndLead = async ({
  form,
  contactForm,
  partnerId,
  origin,
  consentText,
}: SaveApplicationAndLeadProps): Promise<{
  application: Application;
  lead: LeadCreationResponse;
}> => {
  const application = await mapFormToApplication(form);
  const applicationResult = await fetchPostApplication({ body: application });
  const lead = await fetchPostLead({
    body: {
      ...contactForm,
      action: "REAL_ESTATE_PARTNER_LEAD_CREATION",
      applicationId: applicationResult.id,
      partnerId: partnerId,
      origin,
      wantsToSellAProperty: form?.wantsToSellAProperty ? "YES" : "NO",
      consentText,
    },
  });
  return { application: applicationResult, lead };
};

export default saveApplicationAndLead;
